import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/wingman/7b8b7474-e52e-4388-adc0-a2361520c0a4/attachments/8840390a845949e6b9092405676c1743_image.png";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#060A14] text-white flex flex-col items-center justify-center px-4 text-center" data-testid="not-found-page">
      <img src={LOGO_URL} alt="LEOVERA Nutrition" className="h-14 w-auto bg-white rounded-md p-1.5 mb-10" />
      <p className="font-[Outfit] text-[#C0C0C0]/25 font-light leading-none select-none" style={{ fontSize: "clamp(6rem, 20vw, 12rem)" }}>
        404
      </p>
      <span className="mt-2 text-[10px] tracking-[0.4em] uppercase text-[#C0C0C0]">LEOVERA Nutrition</span>
      <h1 className="mt-4 font-[Outfit] text-3xl sm:text-4xl font-light tracking-tight">Pagina non trovata</h1>
      <p className="mt-3 max-w-md text-[#94A3B8] text-sm leading-relaxed">
        La pagina che cerchi non esiste o è stata spostata. Torna al catalogo per continuare la navigazione.
      </p>
      <Link to="/" data-testid="not-found-home-btn"
            className="mt-10 inline-flex items-center gap-3 bg-[#C0C0C0] text-[#060A14] px-8 py-4 rounded-sm text-[11px] tracking-[0.28em] uppercase font-medium hover:bg-white transition-colors">
        <Compass className="w-4 h-4" /> Torna alla Home
      </Link>
    </div>
  );
}
